import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import ReactQuill from 'react-quill-new';
import swal from 'sweetalert2';
var Editor = /*#__PURE__*/function (_Component) {
  function Editor(props) {
    var _this;
    _classCallCheck(this, Editor);
    _this = _callSuper(this, Editor, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.disabled) {
        var quill = _this.refs.quill.getEditor();
        quill.disable();
      }
    });
    _defineProperty(_this, "imageHandler", function () {
      var quill = _this.refs.quill.getEditor();
      var range = quill.getSelection();
      swal({
        title: 'Bifoga bild',
        text: 'Ange URL',
        input: 'text',
        inputPlaceHolder: 'Ange URL',
        confirmButtonText: 'Bifoga',
        focusConfirm: false
      }).then(function (result) {
        if (result.value != null || result.value != '') {
          quill.insertEmbed(range.index, 'image', result.value);
        }
      });
    });
    _defineProperty(_this, "videoHandler", function () {
      var quill = _this.refs.quill.getEditor();
      var range = quill.getSelection();

      // We need to figure out how to generate an embed link for all types of videos
      // Its easy to do with youtube but unsure about vimeo etc.
    });
    _defineProperty(_this, "urlHandler", function (promptRange) {
      var quill = _this.refs.quill.getEditor();
      if (promptRange) {
        swal({
          title: 'Bifoga innehåll',
          text: 'Ange URL',
          input: 'text',
          confirmButtonText: 'Bifoga',
          focusConfirm: false
        }).then(function (result) {
          if (result.value != null && result.value != '') {
            var url = result.value;

            // Add https if the url is missing a protocol
            if (url.indexOf('mailto') == -1 && url.indexOf('tel') == -1 && url.indexOf('ftp') == -1) {
              if (!url.match(/^[a-zA-Z]+:\/\//)) {
                url = 'https://' + url;
              }
              quill.format('link', url);
            } else {
              quill.format('link', false);
            }
          }
        });
      }
    });
    var placeHolderText = '';
    if (_this.props.placeholder) {
      placeHolderText = _this.props.placeholder;
    }
    _this.state = {
      placeHolderText: placeHolderText
    };
    return _this;
  }
  _inherits(Editor, _Component);
  return _createClass(Editor, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var meta = this.props.meta;
      var modules = {
        toolbar: {
          container: [[{
            header: [2, 3, false]
          }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
            list: 'ordered'
          }], ['link', 'image', 'video', 'clean'], ['formula']],
          handlers: {
            image: this.imageHandler,
            link: this.urlHandler
            //video: this.videoHandler, TODO: We need to handle videos as well
          },
          keyboard: {
            bindings: {
              'list autofill': {
                prefix: /^\s*()$/
              }
            }
          }
        }
      };
      var formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', /*'bullet', 'indent', */
      'link', 'image', 'video', 'formula'];
      return /*#__PURE__*/React.createElement("div", null, this.props.label ? /*#__PURE__*/React.createElement("label", null, this.props.label) : null, /*#__PURE__*/React.createElement(ReactQuill, {
        modules: modules,
        formats: formats,
        placeholder: this.state.placeHolderText,
        ref: "quill",
        style: meta.touched && meta.error ? {
          border: '1px solid red'
        } : {},
        value: this.props.input ? this.props.input.value : null,
        onChange: function onChange(value, delta, source) {
          var newValue = value;
          var matches = newValue.match(/&lt;iframe(.*?)\&lt;\/iframe/g);
          if (matches != null) {
            matches.map(function (match) {
              var result = match;
              result = result.replace('<p>', ' ');
              result = result.replace('</p>', '');
              result = result.replace('&nbsp;', ' ');
              newValue = newValue.replace(match, result);
            });
          }
          if (_this2.props.input) {
            _this2.props.input.onChange(newValue);
          }
        },
        onBlur: function onBlur(range, source, quill) {
          if (_this2.props.input) {
            _this2.props.input.onBlur(quill.getHTML());
          }
        },
        onFocus: function onFocus() {
          // Empty block
        }
      }), typeof meta !== 'undefined' ? /*#__PURE__*/React.createElement("div", null, meta.touched && (meta.error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: 0
        },
        className: "error"
      }, meta.error) || meta.warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: 0
        },
        className: "error"
      }, meta.warning))) : null);
    }
  }]);
}(Component);
export default Editor;